import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'antd'
import React, { useState } from 'react'
import ProfileMenu from '../ProfileSection/ProfileMenu'
import { Header } from 'antd/es/layout/layout'
import LOGO from "../../Assests/images/logo3.png";

const AppHeader = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const isDashboard = location.pathname === "/";
  const navigate = useNavigate();
  // const [collapsed, setCollapsed] = useState(false);
  console.log("location.pathname :", location.pathname)

  const handleClickDashboard = () => {
    navigate("/");
  };


  return (
    <Header className="header_main">
      <div className="header_section">
        <div className="header_left">

          {
            location.pathname !== "/" && (
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: "16px",
                  width: 64,
                  height: 64,
                }}
              />
            )
          }
          <img
            alt="logo"
            width={200}
            src={LOGO}
            className="move-dashboard"
            onClick={handleClickDashboard}
          />
        </div>
        <div className="header_right">
          <ProfileMenu />
        </div>
      </div>
    </Header>
  )
}

export default AppHeader